import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import * as _ from 'lodash';
import { UserHeaderService } from '../header/user.header.service';

@Component({
  selector: 'user-heading-dropdown',
  template: require('./user.heading-dropdown.component.html'),
})
export class UserHeadingDropdownComponent implements OnInit, OnChanges {
  @Input() currentState: string;

  menuData: any[] = [];
  currentGlyph: string = '';

  constructor(
    private userHeaderService: UserHeaderService
  ) {}

  ngOnInit(): void {
    this.menuData = this.userHeaderService.getMenuData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentState) {
      const newState: any = _.get(changes, 'currentState.currentValue', 'home.user.userhome');
      this.currentGlyph = this.userHeaderService.getGlyphForState(newState);
    }
  }
}
